<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='科秘书管理' url='/person/sectionsecretary/list'></SearchTitle>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <SearchNormalText v-model='condition.secretaryname' label='姓名'></SearchNormalText>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">管理单元：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.secretarysec" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in managesecOptions" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <SearchNormalText v-model='condition.secretaryno' label='工号'></SearchNormalText>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">类型：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.secretarytype" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in secretarytypeOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
          <AddButton url="/person/sectionsecretary/add" buttonname="新增" v-if="this.condition.rolelevel > 2"></AddButton>
          <ExportButton :url='exportUrl' buttonname="导出"></ExportButton>
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <el-table v-loading="loading" :data="tableData" stripe style="width: 100%;" size="medium">
            <el-table-column prop="SecretaryName" label="姓名">
            </el-table-column>
            <el-table-column prop="SectionName" label="管理单元">
            </el-table-column>
            <el-table-column prop="SecretaryNo" label="工号">
            </el-table-column>
            <el-table-column prop="SecretaryTypeName" label="类型">
            </el-table-column>
            <el-table-column label="是否分配">
              <template slot-scope="scope">
                <span v-bind:style="scope.row.Status == '1'?'color:green;':'color:red;'">{{scope.row.StatusName}}</span>
              </template>
            </el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <span v-bind:style="scope.row.StopName == '启用'?'color:green;':'color:red;'">{{scope.row.StopName}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button @click="Edit(scope.row)" type="text" size="medium">修改</el-button>
                <el-button v-if="scope.row.SecretaryType == '1'" @click="SetRange(scope.row)" type="text" size="medium">设定范围</el-button>
                <el-button v-if="scope.row.Status == '0'" @click="SetUser(scope.row)" type="text" size="medium">分配</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
          <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SecretaryList',
    data() {
      return {
        condition: {
          username: '',
          rolelevel: '',
          secid: '',
          secretaryname: '',
          secretarysec: '',
          secretaryno: '',
          secretarytype: '',
          token: '',
          pageSize: 10,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true
        },
        managesecOptions:[],
        secretarytypeOptions: [{
          value: '1',
          label: '大科秘书'
        }, {
          value: '2',
          label: '科秘书'
        }],
        tableData: null,
        searchUrl: this.$utils.Url.zpgl + '/api/APISecretary/List',
        exportUrl: this.$utils.Url.zpgl + '/api/APISecretary/ListOut',
        loading: true
      }
    },
    methods: {
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.condition.firstSearch = false
        this.condition.currentPage = val
        this.$refs.btnSearch.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.condition.firstSearch = false
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.$refs.btnSearch.Search()
      },
      SetRange: function(row) {
        this.$router.push({
          name: 'SetRange',
          params: {
            id: row.SecretaryID
          }
        })
      },
      Edit: function(row) {
        this.$router.push({
          name: 'SectionSecretaryEdit',
          params: {
            id: row.SecretaryID
          }
        })
      },
      SetUser: function(row) {
        var args = {
          token: this.condition.token,
          id: row.SecretaryID
        }
        this.$http.post(this.$utils.Url.zpgl + '/api/APISecretary/SetUser', args)
          .then(res => {
            console.log(res.data)
            if (res.data.Code === 0) {
              this.$message({
                message: '分配成功',
                type: 'success'
              })
              console.log('分配成功')
              this.$refs.btnSearch.Search()
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
          })
          .catch(err => {
            console.log(err)
            this.$message({
              message: '分配失败',
              type: 'error'
            })
          })
      },
      LoadManageSec:function(){
        var args = {
          token: this.condition.token,
          username: this.condition.username,
          rolelevel: this.condition.rolelevel
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function(data) {
          that.managesecOptions = data.Data
          console.log(that.managesecOptions)
        }, null, null, null)
      }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.condition.username = sessionStorage.getItem('username')
      this.condition.rolelevel = sessionStorage.getItem('rolelevel')
      this.condition.secid = sessionStorage.getItem('secid')
      this.LoadManageSec()
      this.$refs.btnSearch.Search()
    }
  }
</script>

<style>
</style>
